<template>
  <div
    class="msg-ptt"
    v-touch:touchhold="handleMessageLongTouch"
    :class= "!isMobile? 'msg-ptt-pc': ''"
  >
    <div class="ptt" :style="{ width: amrWidth + 'px' }" :class="data.mine?'ptt-mine':''" @click="play">
      <span v-if="data.mine">
        <span>{{ data.length }}"</span>
        <img v-show="!isPlaying" src="./assets/blue-voice-icon.png" />
        <img v-show="isPlaying" src="./assets/voice-playing-right.gif" />
      </span>
      <span v-else>
        <img v-show="!isPlaying" src="./assets/black-voice-icon.png" />
        <img v-show="isPlaying" src="./assets/voice-playing-left.gif" />
        <span>{{ data.length }}"</span>
      </span>
    </div>
    <span class = 'red-rot' v-if = "notRead"></span>
    <span v-if="!isMobile && !translateLoading &&  !amrText"
    :class="data.mine?'translate-text-mine':'translate-text'" @click="convertPtt2Text">转文字</span>
    <div v-if="amrText || translateLoading" class="ptt-text">
      <img
          v-if="translateLoading"
          class="icon-loading anim-rotate"
          src="./assets/loading.svg"
      />
      <span v-if="amrText">{{ amrText }}</span>
    </div>
  </div>
</template>

<script>
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';

const imsdk = IMSDK.create();
export default {
  inject: ['globalData'],
  props: {
    data: Object,
    playing: String,
  },
  data() {
    return {
      formatPath: '',
      amr: null,
      amrText: '',
      amrTextFinish: false,
      selectedText: '',
      isTransfer: false,
      isPlaying: false,
      imsdk: null,
      translateLoading: false,
      notRead: false,
      errorText: '',
    };
  },
  watch: {
    // 监测全局中是否有其他语音进行播放，如果是则停止当前语音
    globalData: {
      handler(val) {
        if (val.playingVoice !== this.data.seq) {
          if (this.amr && this.amr.isPlaying()) {
            this.amr.stop();
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    amrWidth() {
      const ratio = Math.min(this.data.length / 60, 1);
      return 90 + 100 * ratio;
    },
    isMobile() {
      return !this.$platform.pc;
    },
  },
  async mounted() {
    import(/* webpackChunkName: "amr" */ 'benz-amr-recorder').then((BenzAMRRecorder) => {
      this.amr = new BenzAMRRecorder.default();
      this.amr.onEnded(() => {
        this.isPlaying = false;
      });
    });
    if (!this.data.mine) {
      const tags = imsdk.getMessageTags(this.data);
      const savedData = tags.find(item => item.tag === 'ptt_read');
      if (savedData && savedData.value === '1') {
        this.notRead = false;
      } else {
        this.notRead = true;
      }
    }
    // 如果是本地blob图片，或者是外链其他图片，则直接获取
    if (this.data.uuid === 'blob' || this.data.path.indexOf('http') === 0) {
      this.formatPath = this.data.path;
      return;
    }

    // 获得存储的文件路径
    this.formatPath = await SDKUtils.getDownloadUrl({
      path: this.data.path,
      size: this.data.fileSize,
      name: this.data.fileName,
    }, IMSDK.OBJTYPES.OBJ_VOICE);
  },
  deactivated() {
    if (this.amr.isPlaying()) {
      this.amr.stop();
    }
  },
  methods: {
    handleMessageLongTouch() {
      this.$emit('on-long-touch', this.$el);
    },
    // 语音消息标为已读
    addReadTag() {
      this.notRead = false;
      imsdk.setMessageTags(this.data, [{
        tag: 'ptt_read',
        value: '1',
      }]);
    },
    play() {
      if (this.notRead) {
        this.addReadTag();
      }
      this.globalData.playingVoice = this.data.seq; // 原web工作台这里使用的是uuid, 感觉是存在问题的。

      if (this.amr.isInit()) {
        this.amr.playOrPauseOrResume();
        if (this.amr.isPlaying()) {
          this.isPlaying = true;
        } else {
          this.isPlaying = false;
        }
      } else {
        console.log(this.formatPath);
        this.amr.initWithUrl(this.formatPath).then(() => {
          this.amr.playOrPauseOrResume();
          this.isPlaying = true;
        });
      }
    },
    async convertPtt2Text() {
      if (this.notRead) {
        this.addReadTag();
      }
      if (this.translateLoading) {
        return;
      }
      // 3. 上传成功, asr处理
      this.translateLoading = true;
      //  增加10秒的超时处理
      let pttTimeout = setTimeout(() => {
        this.translateLoading = false;
        this.$Toast({ text: '转文字失败', type: 'error' });
        pttTimeout = null;
      }, 10000);
      let strRext = '';
      try {
        const arsRS = await this.doASR(this.formatPath);
        if (!pttTimeout) {
          return;
        }
        clearTimeout(pttTimeout);
        pttTimeout = null;
        this.translateLoading = false;
        const dataRet = JSON.parse(arsRS);
        strRext = dataRet.data.sentenceResult;
      } catch (e) {
        this.$Toast({ text: '转文字失败', type: 'error' });
      }
      if (strRext) {
        // 4. ars成功，发送文本
        this.amrText = strRext;
        this.isTransfer = true;
      } else {
        this.$Toast({ text: '转文字失败', type: 'error' });
      }
    },
    async doASR(url) {
      if (!this.imsdk) {
        // 如果外部未传入sdk实例，则获取或创建全局唯一实例。
        this.imsdk = IMSDK.create();
      }
      // 先瞎写的做个demo
      const message = {
        appId: 1003,
        fileUrl: url,
        voiceFormat: 'amr',
      };
      const HEAD_CMD_CODE = 2;
      const SEC_CMD_CODE = 1536;
      return this.imsdk.sendCmdMessage(HEAD_CMD_CODE, message, SEC_CMD_CODE);
    },
  },
};
</script>

<style lang="less" scoped>
.msg-ptt {
  cursor: pointer;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  padding: 12px 10px;
  border-radius: 0px 6px 6px 6px;
  text-align: left;
  user-select: none;
  img {
    width: 18px;
    vertical-align: top;
  }
  .ptt {
    position: relative;
    &.ptt-mine{
      min-width: 100%;
      text-align: right;
    }
  }
  .red-rot {
      position: absolute;
      right: -14px;
      top: 3px;
      width: 8px;
      height: 8px;
      background: #f75559;
      border-radius: 8px;
    }
  .translate-text{
    position: absolute;
    // height: 20px;
    box-sizing: border-box;
    width: 52px;
    right: -68px;
    transform: translateY(-50%);
    top: 50%;
    background: #f1f2f5;
    border-radius: 10px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    color: rgba(1, 11, 50, 0.41);
    // line-height: 20px;
    padding: 4px 0;
  }
  .translate-text-mine {
    position: absolute;
    // height: 20px;
    box-sizing: border-box;
    width: 52px;
    left: -68px;
    transform: translateY(-50%);
    top: 50%;
    background: #f1f2f5;
    border-radius: 10px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    color: rgba(1, 11, 50, 0.41);
    //line-height: 20px;
    padding: 4px 0px;
  }
  .ptt-text {
    margin-top: 8px;
    padding-top: 8px;
    max-width: 300px;
  }
  .ptt-text::before {
    position: absolute;
    left: 0;
    right: 0;
    border-top: 1px solid #edf0f7;
    content: '';
    top: 37px;
  }
}
.msg-ptt-pc {
  .ptt-text::before {
    border-top: 1px solid #dadee7;
  }
  .red-rot {
    top: 3px;
  }
}
.icon-loading {
    width: 20px;
    height: 20px;
    fill:#edf0f7;
}
.anim-rotate{
  animation: rotate 1s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
